
import SmarttenderApi from '@/api/smarttenderApi'
import { storageMixin } from '.'
const api = new SmarttenderApi()

import calculateFormula from '@/utils/calculateFormula.js'
import tenderLotGroups from 'mixins/tenderLotGroups'

export default {
  mixins: [ storageMixin, tenderLotGroups ],
  data() {
    return {
      mixin_contains: {
        'NUMERIC_INPUT': [
          {text: this.$t('Automation.operator.EQUALS'), value: 'EQUAL', symbol: '='},
          {text: this.$t('Automation.operator.NOT_EQUALS'), value: 'NOT_EQUAL', symbol: '≠'},
          {text: this.$t('Automation.operator.GREATER_THAN'), value: 'MORE_THAN', symbol: '>'},
          {text: this.$t('Automation.operator.LESS_THAN'), value: 'LESS_THAN', symbol: '<'},
          {text: this.$t('Automation.operator.GREATER_THAN_OR_EQUAL_TO'), value: 'MORE_OR_EQUAL', symbol: '≥'},
          {text: this.$t('Automation.operator.LESS_THAN_OR_EQUAL_TO'), value: 'LESS_OR_EQUAL', symbol: '≤'},
        ],
        default: [
          {text: this.$t('Automation.operator.CONTAINS'), value: 'CONTAINS', symbol: '∋'},
          {text: this.$t('Automation.operator.NOT_CONTAINS'), value: 'NOT_CONTAINS', symbol: '∌'},
        ]
      }
    }
  },
  computed: {
    standart_criteria() {
      return this.$store.getters.getStandartCriteria.map(el => ({...el, title: this.$t(el.title)}))
    },
  },
  methods: {
    $_parseListValue(value) {
      let values = value || ''

      if (!values || values.trim() === '') {
        return []
      }
      return values.split(',')
        .filter(item => item !== '')
    },
    getVariablesForFormula(criterias, item) {

      let items = criterias
        .filter(el => {
          let not_current = el.criteriaMark != item?.criteriaMark ,
            not_text =  el.criterionControlType && el.criterionControlType != 'BIG_TEXT',
            not_with_error = !el.formulaError,
            has_bind_level = item?.criterionBindingLevel,
            chck_by_bind_level = item?.criterionBindingLevel == 'TENDER' ? el.criterionBindingLevel == 'TENDER' : true,
            chck_default = item?.criterionKind !== 'VARIANT' && el?.criterionKind === 'DEFAULT',
            chck_variant = (!item || item?.criterionKind === 'VARIANT') && el?.criterionKind === 'VARIANT',
            chack_standart = true

          if ( this.card.useStandardReducedPrice && !item ) {
            // сумма (вес) по всем критериям по справочнику (которые применяются в формуле) должен быть меньше 100 баллов
            chack_standart = el.criterionControlType == 'DICTIONARY' && Math.max(...el.dictionaryValues.map(el => +el.score)) <= 100
          }
          return not_current && chack_standart && not_text && not_with_error 
            && (!has_bind_level || chck_by_bind_level )
            && (chck_default || chck_variant)
        })
        .map((item) => {
          let type = item.criterionControlType,
            val  = ''
          if ( type == 'DICTIONARY' ) {
            val = item.dictionaryValues
              .map((el) => el.title)
              .join(', ')
          } else if ( type == 'CALCULATED'  ) {
            val = item.calculationFormula
          } else if ( type == 'NUMERIC_INPUT' ) {
            val = item.measuringUnit?.unitShortTitle
          }
          return {
            variable: item.formulaCode,
            criterionCode: item.criterionCode,
            disabled: this.checkDisabledVar( item.formulaCode ),
            title: item.title,
            type: type,
            value: val,
            item
          }
        })

      if ( (!item || item?.criterionBindingLevel == 'LOT') && item?.criterionKind !== 'VARIANT' && !this.card.useStandardReducedPrice) {
        let standart = this.$_.cloneDeep(this.standart_criteria)
        if ( !item || !this.reducedPriceAvailable ) {
          standart.pop()
        } else if ( item && this.reducedPriceAvailable ) {
          standart.forEach(el =>  el.disabled = this.checkDisabledVar( el.variable, item ))
        }
        items = items.concat(standart)
        return items
      }
      return items || []
    },
    /**
     * Проверяем, что формула статична. Т.е. ее параметры не изменны
     */
    $_checkStaticFormula(item, criterias) {
      if (item.criterionControlType !== 'CALCULATED') {
        return
      }
      const formulaTokens = item.calculationFormula.match(/\b[a-zA-Z0-9_]+\b/g)

      if (!formulaTokens) {
        return // В формуле нет распознаваемых переменных или функций
      }
      const formulaTokensSet = new Set(formulaTokens)

      const variables = this.getVariablesForFormula(criterias, item).filter(variableItem => {
        if (variableItem && variableItem.item && typeof variableItem.item.formulaCode === 'string') {
          const cleanedFormulaCode = variableItem.item.formulaCode.trim()

          return formulaTokensSet.has(cleanedFormulaCode) && isNaN(Number(cleanedFormulaCode))
        }
        return false
      })

      const validateVariables = variables?.filter(i => i.item && !i.item.fixedValue) || []

      if (!validateVariables.length) {
        return this.$t('Validate.notDunamicFormula')
      }
      return
    },
    checkDisabledVar(variable, item) {
      return variable == 'REDUCEDPRICE' && item && this.card && !this.card.useReducedPrice
    },
    validateFormulaByErrors(html_formula, errors_in_formula) {
      let highlightedFormula = html_formula

      const highlight = text => `<span class="secondary__red--text">${text}</span>`
      const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // Экранируем специальные символы

      const uniqueErrors = [...new Set(errors_in_formula)]
      if (uniqueErrors?.length) {
        const regex = new RegExp(`(${uniqueErrors.map(error => escapeRegExp(error)).join('|')})`, 'g')
        // перебериємо помилки і формуємо з формули html з виділеними помилками з допомогою ф-ї highlight
        highlightedFormula = highlightedFormula.replace(regex, (match) => highlight(match))
      }

      const lastIndex = highlightedFormula.length - 1

      // Запрещённый последний символ
      let last_error = highlightedFormula.charAt(lastIndex).match(/[-+/*,./*(]/)
      if (last_error) {
        highlightedFormula = highlightedFormula.substring(0, lastIndex) + highlight(highlightedFormula.substring(lastIndex, highlightedFormula.length))
        errors_in_formula.push(last_error)
      }

      // Проверяем баланс скобок
      if (highlightedFormula.match(/[(]/g)?.length != highlightedFormula.match(/[)]/g)?.length || highlightedFormula.match(/[()]/g)?.length % 2) {
        errors_in_formula.push('bracket_error')
      }

      return highlightedFormula
    },
    findFormulaErrors(text, variables) {
      // ^[-+/*,./]                  - перший символ - знак
      // [(]\s{0,}[)]                 - дві дужки підряд (відкриваюча + закриваюча)
      // [(]\s{0,}[-+/*,./]           - дужка + знак
      // [-+/*,./]\s{0,}[)]           - знак + дужка
      // [-+/*,./]\s+[-+/*,./]        - кілька знаків підряд з пробілами між ними
      // [\d)]+\s{0,}[a-zA-Z]+        - число або закриваюча дужка і змінна без знаку між ними
      // [a-zA-Z]+\s{0,}[\d(]         - змінна або відкриваюча дужка і число без знаку між ними
      // [-+/*,.]{2,}                 - кілька знаків підряд
      // [a-zA-Z]+\s[a-zA-Z]+         - кілька змінних без знаку між ними
      // [^-a-zA-Z\d()+/*,.\s]+       - недопустимі символи
      // [a-zA-Z]+                    - недопустимі змінні

      // - не підходить в даному випадку, якщо є такий же знак як останній перед останнім, то виділяється він, а не останній  // todo [-+/*,./]$ - останній символ - знак
      let errors = text?.match(/^[-+/*,./]|[(]\s{0,}[)]|[(]\s{0,}[-+/*,./]|[-+/*,./]\s{0,}[)]|[-+/*,./^]\s+[-+/*,./]|[\d)]\s{0,}[a-zA-Z]+|[a-zA-Z]+\s{0,}[\d(]|[-+/,.]{2,}|[a-zA-Z]+\s[a-zA-Z]+|[^-a-zA-Z\d()+/*,.\s/]+|[a-zA-Z]+/g) || []
      // Star more 2
      let manySumbol_error = text?.match(/[*]{3,}/)
      if (manySumbol_error) {
        errors.push(manySumbol_error[0])
      }

      let error = errors.filter(el => !variables.some(variableItem => variableItem.variable == el && !variableItem.disabled && (!variableItem.item?.criterionKind || variableItem.item.criterionKind === 'DEFAULT' || variableItem.item.criterionKind === 'VARIANT')))
      let items = error.filter(el => el.match(/[a-zA-Z]+/g))

      return {
        all_errors: error,
        not_variables: items
      }
    },
    calculationFormulaValidate(item) {
      if (!item.calculationFormula) {
        item.calculationFormulaError = ''
        return ''
      }
      let vars = this.getVariablesForFormula(this.card?.criterias, item)
      if (this.growthBook.use_mathjs) {
        const mathVar = []
        vars.forEach(item => {
          mathVar.push({key: item.variable, value: 1})
        })

        this.standart_criteria.forEach(item => {
          mathVar.push({key: item.variable, value: 1})
        })

        const { highlightedFormula } = calculateFormula(item.calculationFormula, mathVar)

        return highlightedFormula || item.calculationFormula
      }
      let errors = this.findFormulaErrors(item.calculationFormula, vars)
      let html_formula = this.validateFormulaByErrors(item.calculationFormula, errors.all_errors)
      item.calculationFormulaError = html_formula
      return html_formula
    },
    nameValidate(item, deactivate) {
      let res = ''
      if ( this.$_.countBy(this.card?.criterias, 'title' )[item.title] > 1 ) {
        res = this.$t('Tenders.TheNameOfTheCriterionMustBeUnique')
        // this.nameValidate( this.card?.criterias?.find(el => el.title == item.title && item.key != el.key && item.id != el.id) )
      } else if (  item.title?.length > 254 ) {
        res = this.$t('Validate.maxLength', {number: 254, type: this.$tc('Common.characters', 4) })
      }
      item.titleError = res
      if ( deactivate ) {
        deactivate()
      }
      return res
    },
    checkAllCriteriasFormulas() {
      this.card?.criterias?.forEach(el => this.calculationFormulaValidate(el) )
    },
    validateAllCriteria() {
      this.card?.criterias?.forEach(el => {
        el.titleError = this.nameValidate(el)
        el.calculationFormulaError = this.calculationFormulaValidate(el)
      } )
    },
    /**
     * провірка коректності всіх динамічних критеріїв критерія
     * @param {Array} rows все строки
     * @param {Object} item строка
     */
    checkInValidAllDynamic(rows, item) {
      return item.dynamicCriterions?.length && item.dynamicCriterions.some(elem => !this.checkValidDynamicCondition(rows, item, elem).correct)
    },
    /**
     * провірка коректності умови динамічного критерія
     * @param {Array} rows все строки
     * @param {Object} item критерий для которого dynamicCriterions
     * @param {Object} dynamicCriterion условие подключения ( одно из dynamicCriterions )
     */
    checkValidDynamicCondition(rows, item, dynamicCriterion) {
      let row = rows.find(crit => crit.criteriaMark == dynamicCriterion.targetCriterionMark)
      if (!row) {
        return {
          correct: false,
          errorHint: ''
        }
      }
      if (item.criterionBindingLevel === 'TENDER' && row.criterionBindingLevel !== 'TENDER') {
        return {
          correct: false,
          errorHint: this.$t('Tenders.BlockedUSedOtherBiddingLevel')
        }
      }

      let correct = true
      let errorHint = ''

      if (row?.criterionControlType == 'DICTIONARY') {
        let values = this.$_parseListValue(dynamicCriterion?.value)

        correct = row.title == dynamicCriterion.targetCriterionTitle && row.dictionaryValues.some(el => values.includes(el.title))
        errorHint = correct ? null : (dynamicCriterion.comparingMode == 'CONTAINS' ? this.$t('Common.Contains') : this.$t('Common.NotContains'))
      } else if (row?.criterionControlType == 'NUMERIC_INPUT') {
        if (dynamicCriterion.value === null) {
          correct = false
          errorHint = 'пусте значення'
        }
        const value = +dynamicCriterion.value

        const isInteger = Number.isInteger(value) // Проверяем, является ли число целым
        const decimalValuePart = value.toString().split('.')[1]
        let decimalValueCount = decimalValuePart ? decimalValuePart.length : 0

        const allowDecimals = row.allowDecimals || !!row.decimals || false
        if (row.maxValue && value > row.maxValue) {
          correct = false
          errorHint = 'значення більше максимуму'
        } else if (row.minValue && value < row.minValue) {
          correct = false
          errorHint = 'значення менше мінімуму'
        } else if (!allowDecimals && (!isInteger || decimalValueCount)) {
          correct = false
          errorHint = 'значення не ціле'
        } else if (decimalValueCount > 5) {
          correct = false
          errorHint = 'забагато десятичних'
        }
      }

      return {
        correct,
        errorHint
      }
    },
    ckeckAnalogsLocked(item) {
      let type = item.criterionControlType
      let has_fixed = (type == 'BIG_TEXT' || type == 'NUMERIC_INPUT') && !!item.fixedValue

      return has_fixed || item.criterionBindingLevel == 'TENDER'
    },

    checkDisplayCanHide(item) {
      let type = item.criterionControlType
      let has_fixed = (type == 'BIG_TEXT' || type == 'NUMERIC_INPUT') && !!item.fixedValue
      let calculated = type == 'CALCULATED'
      return calculated || has_fixed
    },
    checkDisplayIsLocked(item, rows) {
      let can_hide = this.checkDisplayCanHide(item)
      let has_dictionaries = rows.some(el => {
        let is_list = el.criterionControlType == 'DICTIONARY' && (item.key ? el.key != item.key : el.id != item.id)
        let is_num = el.criterionControlType == 'NUMERIC_INPUT'
        let chck_by_bind_level = item?.criterionBindingLevel == 'TENDER' ? el.criterionBindingLevel == 'TENDER' : true
        // якщо привязаний до тендера то список можливх умов тільки ті що привязані до тендера
        return (is_list || is_num) && chck_by_bind_level
      })
      const allowCriterionKind = ['DEFAULT', 'VARIANT']
      return (!can_hide && !has_dictionaries) || (item.criterionKind && !allowCriterionKind.includes(item.criterionKind))
    },
    checkUnusedCode(item, array, formula, card) {
      let not_used_in_criterias = ( !array || !this.$_.some(array, crit => crit.criterionControlType == 'CALCULATED' && crit.calculationFormula.includes( item.formulaCode)) ),
        not_used_in_formula = !card?.useStandardReducedPrice && !formula?.includes(item.formulaCode)
      return item.formulaCode
            && not_used_in_criterias
            && not_used_in_formula
    },
    async createorUpdateCriteriaCard({ tender, card, checkTenderBySettings }) {
      let code
      if ( card ) {
        let cardInput = {
            id: card.id,
            useReducedPrice: tender.biddingType?.reducedPriceAvailable ? card?.useReducedPrice : false,
            reducedPriceFormula: !tender.biddingType?.reducedPriceAvailable || card.useStandardReducedPrice ? '' : card?.reducedPriceFormula,
            title: card?.title,
          },
          payload = {
            tenderId: tender.tenderId,
            createCriteriaCardInput: {
              ...cardInput,
              criterias: card?.criterias?.map((el, index) => {

                let type = el.criterionControlType
                if ( type != 'NUMERIC_INPUT' && type != 'BIG_TEXT' ) {
                  el.fixedValue = ''
                }
                if ( type != 'NUMERIC_INPUT' ) {
                  el.minValue = null
                  el.maxValue = null
                  el.isBestValueDisplayedWeb = false
                  el.scoreDirection = 'MAX'
                  el.allowDecimals = false
                }
                if ( type != 'CALCULATED' ) {
                  el.calculationFormula = ''
                }
                if ( type != 'DICTIONARY') {
                  el.dictionaryValues = []
                }
                if ( this.checkUnusedCode(el, card?.criterias, cardInput?.reducedPriceFormula , card) ) {
                  el.formulaCode = ''
                }

                const isNotEmptyValue = (value) => value !== null && value !== undefined

                return {
                  allowDecimals: el.allowDecimals || !!el.decimals || false,
                  dictionaryValues: el.dictionaryValues.map(el => ({
                    id: el.id || null,
                    title: el.title,
                    score: +el.score
                  })),
                  scoreDirection: el.scoreDirection ,
                  standartValue: (isNotEmptyValue(el.standartValue) ? +el.standartValue : null),
                  isBestValueDisplayedWeb: el.isBestValueDisplayedWeb ?? false,
                  calculationFormula: el.calculationFormula || '',
                  criterionType: el.criterionControlType,
                  minValue: (isNotEmptyValue(el.minValue) ? +el.minValue : null),
                  maxValue: (isNotEmptyValue(el.maxValue) ? +el.maxValue : null),
                  fixedValue: (isNotEmptyValue(el.fixedValue) ? ('' + el.fixedValue ) : null),
                  //el.fixedValue ? ('' + el.fixedValue ) : '',
                  criteriaMark: el.criteriaMark || el.tag,
                  description: el.description || '',
                  formulaCode: el.formulaCode,
                  title: el.title,
                  attachmentMode: el.attachmentMode,
                  criterionCode: el.criterionCode,
                  id: el.id, //  ?
                  dynamicCriterions: el.dynamicCriterions.map(el => ({
                    id: el.id || null,
                    value: el.value,
                    comparingMode: el.comparingMode,
                    targetCriterionMark: el.targetCriterionMark ,
                  })),
                  criterionKind: el.criterionKind || 'DEFAULT',
                  criterionLevel: el.criterionBindingLevel ,
                  measuringUnitId: el.measuringUnit?.unitId || null,
                  isDisplayed: el.isDisplayed != 'NOT_DISPLAY',
                  useInRedFormula: !!el.formulaCode && !!(card.useStandardReducedPrice ? el.useInRedFormula : card?.reducedPriceFormula?.includes(el.formulaCode)),
                  orderingNumber: index
                }
              })
            }
          }
        code = await api.createorUpdateCriteriaCard( payload )
        if ( !code) {
          throw this.$t('Errors.STHWrong')
        }
        tender.criteryCard = code
      }

      if (checkTenderBySettings) {
        if (this.$_initializeLotGroups) {
          this.$_initializeLotGroups(tender) 
        }
        await api.editTenderDraft(tender)
      }
      return code
    },
    /**
     * Сохранить карту в localStorage
     * @param {Object} tender
     * @param {Object} card карта
     */
    saveCardToLocalStorage(tender, card) {
      this.$_savePropToDBStorage(`criteria.${tender.tenderId}.${card.id}`, card, new Date().setDate(new Date().getDate() + 30))
    },
  }
}
